import styled from "styled-components";
import { FC } from "react";

import { alpha } from "../../../../typography";

export enum DisplayTestIds {
  Component = "display",
}

const Container = styled.div`
  border-bottom: 1px solid var(--color-primary-200);
  ${alpha.primaryDisabled.body3}
`;

type Props = {
  id?: string;
  className?: string;
  testId?: string;
};

export const Display: FC<Props> = ({ id, className, testId, children }) => (
  <Container
    id={id}
    className={className}
    data-testid={testId ?? DisplayTestIds.Component}
  >
    {children}
  </Container>
);
